import React, { useCallback, useEffect } from "react";
import { motion } from "framer-motion/dist/framer-motion";
import Socket from "socket";
import _ from "lodash";

import mystryImg from "assets/images/tw/mystry-word.png";
import checkImg from "assets/images/tw/tw-check.png";
import crossImg from "assets/images/tw/tw-cross.png";
import yourClue from "assets/images/tw/your-clue.png";
import GuessedWord from "../components/GuessedWord";
import TWWaitingScreen from "../components/TWWaitingScreen";
import {
  fadeInVariants,
  bounce_right_to_left_variants_without_children
} from "shared/components/animations";

const TWEvaluating = ({
  isJudgePlayer,
  joke,
  word,
  isActivePlayer,
  activePlayerWord,
  roomId,
  clueSubmitted,
  screens, buzzer_sound,
  default_audio_effect
}) => {
  const instructions = _.get(screens, "evaluating.instructions",
    "WHAT'S THE VERDICT?").split(" ");
  const buttonPressAction = (type) => {


    let data = {};
    switch (type) {
      case "wrong":
        data = {
          action: "wrong-guess",
          roomId
        };
        break;
      case "right":
        data = {
          action: "right-guess",
          roomId
        };
        break;
      default:
        break;
    }
    Socket.sendMessage(data);
  };
  const onEvaluate = useCallback(
    _.debounce((type) => buttonPressAction(type), 1000, {
      leading: true,
      trailing: false
    }),
    []
  );
  useEffect(() => {
    if (isJudgePlayer && !_.isEmpty(default_audio_effect)) {
      buzzer_sound();
    }
  }, [buzzer_sound, isJudgePlayer, default_audio_effect])
  return isJudgePlayer ? (
    <motion.section
      initial="hidden"
      animate="visible"
      exit="exit"
      className="tw-evaluating"
    >
      <GuessedWord image={mystryImg} word={word} />
      <motion.div
        variants={bounce_right_to_left_variants_without_children}
        className="eval-input"
      >
        <motion.input
          variants={fadeInVariants}
          type="text"
          name="name"
          className="input-field"
          value={activePlayerWord}
          disabled={true}
        />
      </motion.div>
      <div className="tw-verdict">
        <h2 className="heading">
          {instructions[0]}<br />
          {instructions[1]} {instructions[2]}
        </h2>
        <motion.div
          variants={bounce_right_to_left_variants_without_children}
          className="tw-verdict-flex"
        >
          <div
            className="cross"
            onClick={() => {
              onEvaluate("wrong");
            }}
          >
            <img src={crossImg} className="img-fluid" alt="crossImg" />
          </div>
          <div
            className="check"
            onClick={() => {
              onEvaluate("right");
            }}
          >
            <img src={checkImg} className="img-fluid" alt="checkImg" />
          </div>
        </motion.div>
      </div>
    </motion.section>
  ) : (
    <TWWaitingScreen
      image={yourClue}
      guessWord={isActivePlayer ? activePlayerWord : clueSubmitted.word}
      joke={joke}
      description={"WAITING FOR EVALUATION..."}
    />
  );
};

export default TWEvaluating;
